import { render } from "./UiInputAutoComplete.vue?vue&type=template&id=c8150890&scoped=true&ts=true"
import script from "./UiInputAutoComplete.vue?vue&type=script&lang=ts"
export * from "./UiInputAutoComplete.vue?vue&type=script&lang=ts"

import "./UiInputAutoComplete.vue?vue&type=style&index=0&id=c8150890&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8150890"]])

export default __exports__